module.exports = __webpack_public_path__ + "img/chevron-up.c4ccbe4a.svg";